export default __webpack_public_path__ + "static/media/bloodlust.f40036f4.png";